// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './theme/marketingFonts';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { muiTheme } from './theme/muiTheme';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

// Добавляем флаги React Router для предотвращения предупреждений
const routerFutureConfig = {
  v7_startTransition: true,
  v7_relativeSplatPath: true
};

// Подавление некоторых предупреждений в консоли
const originalConsoleWarn = console.warn;
console.warn = function() {
  const args = Array.from(arguments);
  
  // Игнорируем предупреждения от Google reCAPTCHA
  const recaptchaWarnings = [
    "A listener indicated an asynchronous response by returning true",
    "[recaptcha]"
  ];
  
  // Проверяем, содержит ли сообщение игнорируемые строки
  const shouldIgnore = args.some(arg => {
    if (typeof arg === 'string') {
      return recaptchaWarnings.some(warning => arg.includes(warning));
    }
    return false;
  });
  
  // Если сообщение не должно быть проигнорировано, вызываем оригинальный console.warn
  if (!shouldIgnore) {
    originalConsoleWarn.apply(console, args);
  }
};

const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

if (!recaptchaSiteKey && process.env.NODE_ENV !== 'production') {
  console.error(
    'REACT_APP_RECAPTCHA_SITE_KEY is missing. Add it to frontend/.env and restart the dev server.'
  );
}

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <HelmetProvider>
      <GoogleReCaptchaProvider
        reCaptchaKey={recaptchaSiteKey || ''}
        scriptProps={{
          async: true,
          defer: true,
          appendTo: 'head',
          nonce: undefined,
        }}
      >
        <BrowserRouter future={routerFutureConfig}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <App />
          </LocalizationProvider>
        </BrowserRouter>
      </GoogleReCaptchaProvider>
      </HelmetProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();